<template>
    <div class="o-services-modal-sidebar">
        <header class="services-modal-sidebar-header">
            <span class="services-modal-sidebar-label">
                {{ headerLabel }}
            </span>
        </header>
        <div
            ref="tilesContainer"
            class="services-modal-tiles"
        >
            <button
                v-for="(tile, index) in preparedItems"
                :key="tile.id"
                :class="['services-modal-tile', tile.cssClass]"
                @click="handleClick(index)"
            >
                <div class="services-modal-tile-details-container">
                    <div class="services-modal-tile-icon-container">
                        <img
                            class="services-modal-tile-icon"
                            :src="tile.icon"
                            :alt="tile.altText"
                        >
                    </div>
                    <span class="services-modal-tile-text">
                        {{ tile.name }}
                    </span>
                </div>
                <div class="services-modal-tile-info-container">
                    <AFloorInfo :text="tile.floor"/>
                    <span
                        v-if="tile.distance"
                        class="services-modal-tile-distance"
                    >
                        <svg-icon
                            v-if="distanceIcon"
                            original
                            :name="`icons/${tile.distanceIcon}`"
                            class="services-modal-tile-distance-icon"
                        />
                        <span class="services-modal-tile-distance-text">
                            {{ tile.distanceText }}
                        </span>
                    </span>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import AFloorInfo from '../../atoms/a-floor-info';

export default {
    name: "OServicesModalSidebar",
    props: {
        items: {
            type: Array,
            required: true
        },
        distanceIcon: {
            type: String,
            default: ''
        },
        headerLabel: {
            type: String,
            default: ''
        }
    },
    components: {
        AFloorInfo
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        preparedItems() {
            const items = [...this.items];
            const t = this.t;

            return items.filter(i => i.distance).map(service => {
                const floor = t(service, 'floor') || '';

                return {
                    ...service,
                    floor
                }
            })
        }
    },
    methods: {
        handleClick(index) {
            this.$emit('onServiceClick', index)
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
